
import Vue from 'vue'

import PortalVue from 'portal-vue'
Vue.use(PortalVue)

//navigation menus
Vue.component('main-menu', require('./components/navigation/MainNavigationMenu.vue').default);
Vue.component('mobile-menu', require('./components/navigation/MobileNavigationMenu.vue').default);
Vue.component('mega-menu', require('./components/navigation/MegaMenu.vue').default);

//plugins
Vue.component('kma-slider', require('./components/KMASliderModule.vue').default);
Vue.component('search-box', require('./components/SearchBox.vue').default);
Vue.component('expandable-sidebar', require('./components/ExpandableSidebar.vue').default);
Vue.component('text-sizer', require('./components/TextSizer.vue').default);
Vue.component('action-bar', require('./components/ActionBar.vue').default);
Vue.component('video-feed', require('./components/VideoFeed.vue').default);

const app = new Vue({
    el: '#app',

    data: {
        clientHeight: 0,
        windowHeight: 0,
        windowWidth: 0,
        isScrolling: false,
        scrollPosition: 0,
        mobileMenuOpen: false,
        howDoIOpen: false,
        mobileHowDoIOpen: false,
        searchBoxOpen: false,
        textSize: 0,
        wrapper: {}
    },

    methods: {
        handleScroll () {
            this.scrollPosition = window.scrollY;
            this.isScrolling = this.scrollPosition > 40;
        },
        handleResize() {
            this.windowWidth = window.innerWidth;
            this.windowHeight = window.innerHeight;
        },
        toggleMenu() {
            if(this.mobileHowDoIOpen) this.mobileHowDoIOpen = false;
            if(this.howDoIOpen) this.howDoIOpen = false;
            if(this.searchBoxOpen) this.searchBoxOpen = false;
            this.$nextTick(() => {
                this.mobileMenuOpen = ! this.mobileMenuOpen;
            });
        },
        toggleHowDoI() {
            if(this.mobileHowDoIOpen) this.mobileHowDoIOpen = false;
            if(this.searchBoxOpen) this.searchBoxOpen = false;
            if(this.mobileMenuOpen) this.mobileMenuOpen = false;
            this.$nextTick(() => {
                this.howDoIOpen = ! this.howDoIOpen;
            });
        },
        toggleMobileHowDoI() {
            if(this.searchBoxOpen) this.searchBoxOpen = false;
            if(this.howDoIOpen) this.howDoIOpen = false;
            if(this.mobileMenuOpen) this.mobileMenuOpen = false;
            this.$nextTick(() => {
                this.mobileHowDoIOpen = ! this.mobileHowDoIOpen;
            });
        },
        toggleSearchBox() {
            if(this.mobileHowDoIOpen) this.mobileHowDoIOpen = false;
            if(this.howDoIOpen) this.howDoIOpen = false;
            if(this.mobileMenuOpen) this.mobileMenuOpen = false;
            this.$nextTick(() => {
                this.searchBoxOpen = ! this.searchBoxOpen;
            });
        }

    },

    created () {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
        this.handleScroll();
        this.handleResize();
    },

    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }

})
